<template>
  <v-footer app height="auto" class="px-6 py-4" absolute>
    <v-row>
      <p v-if="terms" class="footer-link px-3 ma-0 mt-2">
        <a id="footer-terms-conditions-link" target="_blank" class="button is-link" :href="termsLink">{{
          $t("Terms & Conditions")
        }}</a>
      </p>
      <p v-if="privacyPolicy" class="footer-link px-3 ma-0 mt-2">
        <a id="footer-privacy-policy-link" target="_blank" class="button is-link" :href="privacyPolicyLink">{{
          $t("Privacy Policy")
        }}</a>
      </p>
      <p v-if="cookies" class="footer-link px-3 ma-0 mt-2">
        <a id="footer-cookies-link" target="_blank" class="button is-link" :href="cookiesLink">{{ $t("Cookies") }}</a>
      </p>
      <p class="footer-link px-3 pt-0 ma-0" v-if="langSwitcher">
        <LanguageSelection></LanguageSelection>
      </p>
    </v-row>
    <span @dblclick.prevent="showVersion" class="copyright ma-0">
      <v-icon size="1em" color="secondary">far fa-copyright</v-icon>
      {{ companyName }} {{ year }}
    </span>
  </v-footer>
</template>

<script>
import LanguageSelection from "./base/LanguageSelection";
export default {
  name: "Footer",
  props: {
    langSwitcher: {
      default: false,
      type: Boolean,
    },
    companyName: {
      default: "Eagle Eye Networks",
      type: String,
    },
    termsLink: {
      default: `${config.myaccountURL}/#/terms`,
      type: String,
    },
    privacyPolicyLink: {
      default: "https://www.een.com/privacy-policy/",
      type: String,
    },
    cookiesLink: {
      default: `${config.myaccountURL}/#/cookies`,
      type: String,
    },
    terms: {
      default: true,
      type: Boolean,
    },
    privacyPolicy: {
      default: true,
      type: Boolean,
    },
    cookies: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  components: {
    LanguageSelection,
  },
  methods: {
    showVersion() {
      this.$store.dispatch("toastMessage", {
        showing: true,
        text: `Version ${this.versionNumber}`,
        timeout: -1,
        color: "primary",
      });
    },
  },
  computed: {
    versionNumber() {
      if (this.config.buildNumber !== null && this.config.buildNumber.length > 0) {
        return `${this.config.version} (build ${this.config.buildNumber})`;
      }
      return this.config.version;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/main";
.is-text-right {
  text-align: right;
}
footer {
  background-color: #555555 !important;
  color: #cccccc !important;
  z-index: 1000;
  bottom: 0;
  width: 100%;
}
.isIE {
  footer {
    background-color: #555555 !important;
    color: #cccccc !important;
  }
}
footer .button.is-link {
  color: #cccccc !important;
  text-decoration: none;
  font-weight: normal !important;
  text-transform: capitalize !important;
}
footer .button.is-link.is-active,
.button.is-link.is-hovered,
.button.is-link:active,
.button.is-link:hover {
  background-color: transparent !important;
  color: #24aef5 !important;
  font-weight: normal !important;
}
footer .button.is-link.is-focused,
.button.is-link:focus {
  background-color: transparent !important;
  font-weight: normal !important;
}
p.footer-link {
  color: #cccccc !important;
}
p.copyright {
  color: #cccccc !important;
  user-select: none;
}
.button:active,
.button.is-active {
  -webkit-box-shadow: none;
  box-shadow: none;
}
@media (max-width: 992px) {
  p.copyright {
    padding: 14px 0;
  }
}
@media (max-width: 768px) {
  footer .column {
    padding: 0;
    text-align: center;
  }
  footer .column:not(:first-child) .button.is-link {
    padding: 0px 10px;
  }
  footer .column:first-child .button.is-link {
    padding-bottom: 15px;
  }
  footer .button.is-link {
    height: auto !important;
  }
}
</style>
